import { Navigate, Outlet } from 'react-router';

import GlobalSuspenseFallback from '~/pages/Fallback/GlobalSuspenseFallback';

import { useAppEnv } from './useAppEnv';

/**
 * @description 브라우저 전용 라우트 그룹 Guard (`/guest` 등)
 * - 브릿지 응답 대기 중: 로딩 화면
 * - 브라우저: 하위 라우트 진입 허용
 * - 그 외(웹뷰/개발 모드/무응답): 루트로 이동
 */
const BrowserOnly = () => {
  const { bridgeStatus, isWebView, isDevMode } = useAppEnv();

  if (bridgeStatus === 'pending') {
    return <GlobalSuspenseFallback />;
  }

  return !isWebView && !isDevMode ? <Outlet /> : <Navigate to="/" replace />;
};

export default BrowserOnly;
